import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StudentfromcontrolService {

  userdata:any;

  constructor() {
    if (typeof sessionStorage !== 'undefined') {
      this.userdata = JSON.parse(
        `${
          typeof sessionStorage !== 'undefined'
            ? sessionStorage.getItem('user')
            : null
        }`
      );
    }
   }

  studentformcrontoldata = {
    student: {

      "personal_details": [
        {
          key: "first_name",
          disable: false
        },
        {
          key: "last_name",
          disable: false
        },
        {
          key: "course_id",
          disable: true
        },
        {
          key: "phone_number",
          disable: true
        },
        {
          key: "email",
          disable: true
        },
        {
          key: "password",
          disable: true
        },
        {
          key: "hallTicket_number",
          disable: true
        },
        {
          key: "dost_id",
          disable: true
        },
        {
          key: "date_of_birth",
          disable: true
        },
        {
          key: "adhar_number",
          disable: true
        },
        {
          key: "caste_id",
          disable: true
        },
        {
          key: "sub_caste",
          disable: true
        },
        {
          key: "gender_id",
          disable: true
        },
        {
          key: "religion_id",
          disable: true
        },
        {
          key: "academic_regulation_id",
          disable: true
        },
        {
          key: "academic_year_id",
          disable: true
        },
        {
          key: "semester_id",
          disable: true
        },
        {
          key: "mentor_id",
          disable: true
        },
        {
          key: "roll_number",
          disable: true
        },
        {
          key: "status_id",
          disable: true
        },
        {
          key: "joinging_date",
          disable: true
        },
        {
          key: "course_completion_date",
          disable: true
        },
        {
          key: "hobbies",
          disable: true
        },
        {
          key: "interested_extra_activities",
          disable: true
        },
        {
          key: "participation_in_ncc_nss",
          disable: true
        },
        {
          key: "participation_in_sports_games",
          disable: true
        },
        {
          key: "future_goal",
          disable: true
        },
      ],

      "education_qualifications": [
        {
          key: "qualification_id",
          disable: true
        },
        {
          key: "start_year",
          disable: true
        },
        {
          key: "end_year",
          disable: true
        },
        {
          key: "university_name",
          disable: true
        },
        {
          key: "institution_name",
          disable: true
        },
        {
          key: "course_name",
          disable: true
        },
        {
          key: "percentage",
          disable: true
        }
      ],

      "addresses": [
        {
          key: "country_id",
          disable: false
        },
        {
          key: "state_id",
          disable: false
        },
        {
          key: "address_line1",
          disable: false
        },
        {
          key: "address_line2",
          disable: false
        },
        {
          key: "city",
          disable: false
        },
        {
          key: "pincode",
          disable: false
        },
      ],

      "family_details":[
        {
          key: "fathers_name",
          disable: true
        },
        {
          key: "mothers_name",
          disable: true
        },
        {
          key: "fathers_occupation",
          disable: true
        },
        {
          key: "mothers_occupation",
          disable: true
        },
        {
          key: "annual_income",
          disable: true
        },
        {
          key: "parent_contact_number",
          disable: true
        },
        {
          key: "number_of_brothers",
          disable: true
        },
        {
          key: "number_of_sisters",
          disable: true
        }
      ]
    },

    orthers: {

      "personal_details": [
        {
          key: "first_name",
          disable: true
        },
        {
          key: "last_name",
          disable: false
        },
        {
          key: "course_id",
          disable: false
        },
        {
          key: "phone_number",
          disable: false
        },
        {
          key: "email",
          disable: false
        },
        {
          key: "password",
          disable: false
        },
        {
          key: "hallTicket_number",
          disable: false
        },
        {
          key: "dost_id",
          disable: false
        },
        {
          key: "date_of_birth",
          disable: false
        },
        {
          key: "adhar_number",
          disable: false
        },
        {
          key: "caste_id",
          disable: false
        },
        {
          key: "sub_caste",
          disable: false
        },
        {
          key: "gender_id",
          disable: false
        },
        {
          key: "religion_id",
          disable: false
        },
        {
          key: "academic_regulation_id",
          disable: false
        },
        {
          key: "academic_year_id",
          disable: false
        },
        {
          key: "semester_id",
          disable: false
        },
        {
          key: "mentor_id",
          disable: false
        },
        {
          key: "roll_number",
          disable: false
        },
        {
          key: "status_id",
          disable: false
        },
        {
          key: "joinging_date",
          disable: false
        },
        {
          key: "course_completion_date",
          disable: false
        },
        {
          key: "hobbies",
          disable: false
        },
        {
          key: "interested_extra_activities",
          disable: false
        },
        {
          key: "participation_in_ncc_nss",
          disable: false
        },
        {
          key: "participation_in_sports_games",
          disable: false
        },
        {
          key: "future_goal",
          disable: false
        },
      ],

      "education_qualifications": [
        {
          key: "qualification_id",
          disable: false
        },
        {
          key: "start_year",
          disable: false
        },
        {
          key: "end_year",
          disable: false
        },
        {
          key: "university_name",
          disable: false
        },
        {
          key: "institution_name",
          disable: false
        },
        {
          key: "course_name",
          disable: false
        },
        {
          key: "percentage",
          disable: false
        }
      ],

      "addresses": [
        {
          key: "country_id",
          disable: false
        },
        {
          key: "state_id",
          disable: false
        },
        {
          key: "address_line1",
          disable: false
        },
        {
          key: "address_line2",
          disable: false
        },
        {
          key: "city",
          disable: false
        },
        {
          key: "pincode",
          disable: false
        },
      ],

      "family_details":[
        {
          key: "fathers_name",
          disable: false
        },
        {
          key: "mothers_name",
          disable: false
        },
        {
          key: "fathers_occupation",
          disable: false
        },
        {
          key: "mothers_occupation",
          disable: false
        },
        {
          key: "annual_income",
          disable: false
        },
        {
          key: "parent_contact_number",
          disable: false
        },
        {
          key: "number_of_brothers",
          disable: false
        },
        {
          key: "number_of_sisters",
          disable: false
        }
      ]
    }
  }

  studentformcrontol() {
    if(this.userdata?.data.user_role === "STUDENT"){
      return this.studentformcrontoldata.student
    }else{
      return this.studentformcrontoldata.orthers
    }
  }
}
